exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".maxWidth-0976a9de{max-width:150px}.plusIcon-af03e069{border:2px solid #E0E0E0;border-radius:50%;display:block;margin:0 auto;background:#FFF;object-fit:cover}.badges-64b34cd6{max-width:500px}.badges-64b34cd6 *>button.badgeButton-0727feaa{display:flex;align-items:center;justify-content:center;padding:2px 0px;height:152px;flex-basis:150px;border-radius:0px}.badges-64b34cd6 *>button.selectedBadgeButton-557db829{padding:5px 0px}\n", ""]);

// Exports
exports.locals = {
	"maxWidth": "maxWidth-0976a9de",
	"plusIcon": "plusIcon-af03e069",
	"badges": "badges-64b34cd6",
	"badgeButton": "badgeButton-0727feaa",
	"selectedBadgeButton": "selectedBadgeButton-557db829"
};